import { render, staticRenderFns } from "./exbdadd.vue?vue&type=template&id=2019dfda&scoped=true"
import script from "./exbdadd.vue?vue&type=script&lang=js"
export * from "./exbdadd.vue?vue&type=script&lang=js"
import style0 from "./exbdadd.vue?vue&type=style&index=0&id=2019dfda&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2019dfda",
  null
  
)

export default component.exports